import React from "react";
import Page from "../../components/shared/pages/Page";
import Loading from "../../components/shared/loaders/Loading";
import store from "../../Store";
import { setDashboardMenu } from "../../routes/main-route/MainRoute-Actions";
import { fetchPendingSites, isNotDeployed, unwrapList } from "./billingApi";

const TONE = { pending_payment: "warn", payment_failed: "err" };
const LABEL = {
  pending_payment: "pending payment",
  payment_failed: "payment failed",
};

// Screen 3 — support view: sites that are not live because their first
// invoice is unpaid (charge in flight / awaiting SCA) or failed.
class BillingProvisioning extends React.Component {
  state = { loading: true, notDeployed: false, error: "", rows: [] };

  componentDidMount() {
    document.querySelector("body").classList.add("organization-dashboard");
    store.dispatch(setDashboardMenu(""));

    fetchPendingSites()
      .then((res) => this.setState({ rows: unwrapList(res), loading: false }))
      .catch((err) => {
        if (isNotDeployed(err)) {
          this.setState({ notDeployed: true, loading: false });
        } else {
          this.setState({ error: "Could not load pending sites.", loading: false });
        }
      });
  }

  componentWillUnmount() {
    document.querySelector("body").classList.remove("organization-dashboard");
  }

  render() {
    const { loading, notDeployed, error, rows } = this.state;

    return (
      <Page title="Provisioning">
        <div className="heading-block pr-60">
          <div className="title-block">
            <h2>Provisioning oversight</h2>
            <p className="billing-sub">
              Sites awaiting payment or failed — “why isn’t this site live
              yet?” is usually an unpaid or SCA-blocked invoice. Resolve in
              Stripe; the webhook flips the site live.
            </p>
          </div>
        </div>

        {notDeployed ? (
          <div className="billing-notice">
            The billing endpoints are not deployed yet
            (portal-api&nbsp;· <code>stripe-ground-zero</code>). This screen
            will populate once <code>GET /admin/billing/pending-sites</code> is
            live.
          </div>
        ) : error ? (
          <div className="billing-notice billing-notice--error">{error}</div>
        ) : null}

        <div className="table-block table-responsive pr-60">
          <table className="table">
            <thead>
              <tr>
                <th>Organization</th>
                <th>Site</th>
                <th>Status</th>
                <th>Pending invoice</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5} className="text-center">
                    <Loading />
                  </td>
                </tr>
              ) : rows.length ? (
                rows.map((row, i) => {
                  const st = row.provision_status || "—";
                  return (
                    <tr key={i}>
                      <td>{row.organization_name || row.org || "—"}</td>
                      <td>{row.site_name || row.site || row.display_name || "—"}</td>
                      <td>
                        <span className={`billing-badge ${TONE[st] || "off"}`}>
                          {LABEL[st] || st}
                        </span>
                      </td>
                      <td>
                        <code>{row.pending_invoice_id || "—"}</code>
                      </td>
                      <td className="text-center">
                        {row.pending_invoice_id ? (
                          <a
                            href={`https://dashboard.stripe.com/invoices/${row.pending_invoice_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="billing-link-btn"
                            title="Open the invoice in Stripe"
                          >
                            ↗ Invoice
                          </a>
                        ) : null}
                      </td>
                    </tr>
                  );
                })
              ) : !notDeployed ? (
                <tr>
                  <td colSpan={5} className="text-center">
                    Nothing pending — all sites are provisioned
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </Page>
    );
  }
}

export default BillingProvisioning;
